import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const filterInit = {
    page: 1,
};


export const clearFilterShortcutPayload = (history) => {
    if (history) {

        history.replace({ state: null });
    }
    return;
};

export const importFilterShortcutPayload = (
    history, locationState, thisComponent, callback
) => {
    const { filter, ...restPayload } = locationState?.queryPayload ?? {};
    if (locationState) {

        thisComponent.setState((prevState) => ({
            ...prevState,
            queryPayload: {
                ...prevState.queryPayload,
                page: filterInit.page,
                filter: {
                    ...filter,
                },
                ...restPayload,
            },
        }), () => {
            callback && callback();
            clearFilterShortcutPayload(history);
        });
    }
};
export const importFilterShortcutScooterMapPayload = (
    history, locationState, thisComponent, callback
) => {
    const { filter, ...restPayload } = locationState?.queryPayload ?? {};
    if (locationState) {

        thisComponent.setState((prevState) => ({
            ...prevState,
            queryPayload: {
                ...prevState.queryPayload,
                filter: {
                    ...filter,
                },
                ...restPayload,
            },
        }), () => {
            callback && callback();
            clearFilterShortcutPayload(history);
        });
    }
};
export const importFilterShortcutTicketMapPayload = (
    history, locationState, thisComponent, callback
) => {
    const { filter, ...restPayload } = locationState?.queryPayload ?? {};
    if (locationState) {
        thisComponent.queryPayload = {
            ...filter,
            ...restPayload,
        };
        callback && callback();
        clearFilterShortcutPayload(history);
    }

};

export default function useFilterShortcut(
    [ payload, setPayload ],
) {
    const history = useHistory();
    const location = useLocation();
    const { state: locationState } = location;

    useEffect(() => {
        if (locationState && locationState !== null) {
            const { filter, ...restPayload } = locationState?.queryPayload ?? {};
            setPayload({
                ...payload,
                page: filterInit.page,
                filter: {
                    ...filter,
                },
                ...restPayload,
            });
            clearFilterShortcutPayload(history);
        }
    }, [history, payload, locationState, setPayload]);

    return locationState;
};
